import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import QRCode from 'qrcode';

import { showOverlayOrGo, showOverlay } from './components/share_overlay';

require('jquery');
Rails.start();
Turbolinks.start()

window.$ = $;
window.jQuery = jQuery;

const setPageHash = (hash) => {
  if ( history.pushState ) {
    history.pushState(null, null, hash);
  } else {
    location.hash = hash;
  }
}

let backCount = 0;

document.addEventListener('turbolinks:click', function() {
  backCount = 0;
});

document.addEventListener('turbolinks:load', function() {
  $('canvas.qr').each(function() {
    QRCode.toCanvas(this, $(this).data('qr-content'), {
      color: {
        light: '#0000'
      },
      width:  $(this).data('qr-width'),
      height: $(this).data('qr-height')
    }, function (error) {})
  });
});

$(function() {

  backCount = 0;
  
  $(window).scroll(function () {
    const vTop = $(window).scrollTop() + $(window).height();
    $('.load-more').each(function() {
      if ($(this).offset().top <= vTop) {
        Rails.fire(this, 'click');
      }
    });
  });

  if (window.location.hash.substring(0, 5) == '#wego') {
    const go = window.location.hash.split('-')[1]
    const $link = $(`a.sool[data-go=${go}]`);
    if ($link.length) {
      showOverlayOrGo($link.attr('href'));
    }
  }
  
});

$(document).on('ajax:beforeSend.cc-data-loading', '[data-loading]', function(e) {
  $(this).text($(this).data('loading'));
});

// $(document).on('ajax:beforeSend.cc-load-trigger', '[data-load-trigger]', function(e) {
//   Turbolinks.controller.pushHistoryWithLocationAndRestorationIdentifier($(this).attr('href'), Turbolinks.uuid());
// });

$(document).on('ajax:success.cc-load-trigger', '[data-load-trigger]', function(e) {
  const [data, status, xhr] = e.detail;
  const $data = $(data);
  $('[data-remote-to]').each(function() {
    $(this).html($data.find(`[data-remote-to=${$(this).data('remote-to')}]`).html());
  });
  $('[data-remote-append]').each(function() {
    $(this).append($data.find(`[data-remote-append=${$(this).data('remote-append')}]`).html());
  });
});

$(document).on('click', '.tb-back', function(e) {
  if ((history.length > 1) && (backCount < 2) ) {
    backCount += 1;
    history.back();
    e.preventDefault();
    return false;
  } else {
    backCount = 0;
  }
});

$(document).on('click', '.sool', function(e) {
  if (showOverlay) {
    setPageHash(`#wego-${$(this).data('go')}`);
    showOverlayOrGo($(this).attr('href'));
    e.preventDefault();
    return false;
  }
});

$(document).on('click', '.wechat-overlay, .wechat-overlay .close', function(e) {
  setPageHash('');
  $('.wechat-overlay').hide();
  e.preventDefault();
  return false;
});